import { StackableFusuma } from '~/components/modal/StackableFusuma'
import { useReserveOverlay } from '~/navigation'
import { NotesBody } from './NotesBody'

export function NotesFusuma() {
  const [context, willBeUnmounted] = useReserveOverlay('NEW_RESERVE_INPUT_NOTE')
  if (context === undefined) {
    return null
  }
  return (
    <StackableFusuma title="注意事項" willBeUnmounted={willBeUnmounted}>
      <div className="p-3">
        <NotesBody />
      </div>
    </StackableFusuma>
  )
}
